import { SxProps, Theme } from '@mui/material';

const styles: SxProps<Theme> = {
  marginRight: '8px',
};

export default styles;
